import * as React from "react";
import { useAuthReducer } from "./Hooks/useAuth";
import { useFilterReducer } from "./Hooks/useFilter";
import { useGroupSettingReducer } from "./Hooks/useGroupSetting";
import { useApiReducer } from "./Hooks/useApi";
import { useErrorReducer } from "./Hooks/useError";

const ReducerContext = React.createContext(undefined);

export const Provider = ({ children }) => {
  const value = {
    auth: useAuthReducer(),
    filter: useFilterReducer(),
    groupSetting: useGroupSettingReducer(),
    api: useApiReducer(),
    error: useErrorReducer(),
  };
  return (
    <ReducerContext.Provider value={value}>{children}</ReducerContext.Provider>
  );
};

export const useProvider = () => {
  const context = React.useContext(ReducerContext);

  if (context === undefined) {
    throw new Error("useProvider must be used within a BOAppProvider");
  }
  return context;
};
